import { Injectable } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
declare let gtag: any;

@Injectable({
    providedIn: 'root',
})
export class GoogleAnalytiscService {
    constructor(private router: Router) {
        router.events
            .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((nav: NavigationEnd) => {
                gtag('config', 'G-WYFB1W4SMN', { page_path: nav.url });
            });
    }
    trackEvent(eventName: string, page_title: string): void {
        gtag('event', eventName, { page_title: page_title });
    }
}
